import {Injectable, InjectionToken} from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';

import {TimecardLookupData} from '../../../../common/timecard.model';
import {ApiRoutes} from '../../../../common/api-routes';
import {TimecardTypes} from '../../../../common/timecard.enum';

export interface ITimecardLookupService {
  retrieveAllTimecardLookupData(): Observable<{ [key in keyof typeof TimecardTypes]?: TimecardLookupData }>;
}
export const TimecardLookupServiceToken = new InjectionToken<ITimecardLookupService>('ITimecardLookupService');

@Injectable({
  providedIn: 'root'
})
export class UsTimecardLookupService implements ITimecardLookupService {

  constructor(private _http: HttpClient) { }

  retrieveTimecardLookupData(): Observable<TimecardLookupData> {
    const params = new HttpParams()
      // API Expect the timecardType = CREW
      .set('timecardType', TimecardTypes.CREW);
    return this._http.get<TimecardLookupData>(`${ApiRoutes.Timecard}/lookup`, {params});
  }

  retrieveSagTimecardLookupData(): Observable<TimecardLookupData> {
    const params = new HttpParams()
        // API Expect the timecardType = SAG
      .set('timecardType', TimecardTypes.SAG);
    return this._http.get<TimecardLookupData>(`${ApiRoutes.Timecard}/lookup`, {params});
  }
  retrieveAllTimecardLookupData(): Observable<{ [key in keyof typeof TimecardTypes]?: TimecardLookupData }> {
    return forkJoin({
      CREW: this.retrieveTimecardLookupData(),
      SAG: this.retrieveSagTimecardLookupData()
    }).pipe(
      map((result) => ({
        [TimecardTypes.CREW]: result.CREW,
        [TimecardTypes.SAG]: result.SAG
      }))
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class UkTimecardLookupService implements ITimecardLookupService {

  constructor(private _http: HttpClient) { }

  retrieveTimecardLookupData(): Observable<TimecardLookupData> {
    const params = new HttpParams()
      // API Expect the timecardType = CREW
      .set('timecardType', TimecardTypes.CREW);
    return this._http.get<TimecardLookupData>(`${ApiRoutes.Timecard}/regions/uk/lookup`, {params});
  }

  retrieveAllTimecardLookupData(): Observable<{ [key in keyof typeof TimecardTypes]?: TimecardLookupData }> {
    return this.retrieveTimecardLookupData().pipe(
      map((crewData) => ({
        [TimecardTypes.CREW]: crewData,
        [TimecardTypes.SAG]: { dayType1: [], dayType2: [], payType: [] } as TimecardLookupData
      }))
    );
  }
}
